import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import store from './sotre';
import App from './App';
// TODO 删除
import '@shangqi/cube-component/dist/cube-component.min.css';
import '@sqke/design/dist/esm/index.css';
import './index.less';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <HashRouter>
      <ConfigProvider locale={locale}>
        <App />
      </ConfigProvider>
    </HashRouter>
  </Provider>,
);
